import { render } from "./AnaliticalReferrals.vue?vue&type=template&id=29f41dc5&scoped=true"
import script from "./AnaliticalReferrals.vue?vue&type=script&lang=js"
export * from "./AnaliticalReferrals.vue?vue&type=script&lang=js"

import "./AnaliticalReferrals.vue?vue&type=style&index=0&id=29f41dc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f41dc5"]])

export default __exports__